module.exports = __webpack_public_path__ + "static/media/femenino.37d5594a.png";